import * as React from 'react';
import { NormalizedSearchResult } from '../../../common/d7/common';
import { getSearchResults } from '../../../common/d7/search';
import { contentTypeToIcon } from '../../../common/helpers/icons';
import { useInViewLoading } from '../../../common/hooks/useInViewLoading';
import { useSearchResults } from '../../../common/hooks/useSearchResults';
import { ImageRenditionPresets } from '../../../common/image-rendition';
import { StyledHiddenTrigger, StyledLoader } from '../../../common/loading';
import { useTranslations } from '../../../common/translation';
import { ImageCards } from '../../../components/image-cards/ImageCards';
import { InstagramLoader } from '../../../components/instagram-loader/InstagramLoader';
import translations from '../translations';
import { ArticleResultsProps } from './ArticleResults.props';
import { StyledArticleNoResults, StyledArticleResults } from './ArticleResults.styles';

export const ArticleResults = ({ hiddenResults, query }: ArticleResultsProps) => {
  const { locale, t } = useTranslations(translations);
  const { hasNextPage, isLoading, isQuerying, loadNextPage, searchResults } = useSearchResults(
    query,
    getSearchResults,
    { locale, irsPreset: ImageRenditionPresets.Promo, orderField: 'releaseDate' },
  );
  const inViewRef = useInViewLoading(loadNextPage, isQuerying);

  const contentType: ContentType = 'Articles';

  if (!isLoading && (searchResults || []).length === 0) {
    return <StyledArticleNoResults>{t('noResultsText', 'No results')}</StyledArticleNoResults>;
  }

  return (
    <StyledArticleResults className='search-results-container'>
      {isLoading && <InstagramLoader />}
      {!isLoading && (searchResults || []).length > 0 && (
        <>
          <ImageCards
            cards={searchResults
              .filter(({ id }: NormalizedSearchResult) => !(hiddenResults && id && hiddenResults.includes(id)))
              .map(({ categories, date, image, title, url }: NormalizedSearchResult) => ({
                categories,
                title,
                alt: image?.alt || title,
                src: image?.src || contentTypeToIcon[contentType],
                subtitle: date,
                to: url,
              }))}
            showCategories={true}
            ratio={0.8}
          />
          {hasNextPage() && (
            <>
              <StyledHiddenTrigger ref={inViewRef} />
              <StyledLoader isVisible={isQuerying} />
            </>
          )}
        </>
      )}
    </StyledArticleResults>
  );
};
